export default __webpack_public_path__ + "static/media/02_2_overview-additional-documents.799d8af6.png";